import React, { useEffect, useState } from "react";
import { createGlobalStyle } from "styled-components";
import { getProfile } from "../api/profileApi";
import { ThemeModel } from "../models/ProfileModel";

const GlobalStyle = createGlobalStyle<{ profile: ThemeModel }>`
  body {
    background-color: ${(props) =>
        props.profile.BackgroundColour || "#ffffff"} ;
    color: ${(props) => props.profile.TextColour || "#000000"} !important;
    font-size: ${(props) => props.profile.FontSize || "12"}px !important;
  }

  form {
    background-color: ${(props) =>
        props.profile.BackgroundColour || "#ffffff"} ;
    color: ${(props) => props.profile.TextColour || "#000000"} !important;
    font-size: ${(props) => props.profile.FontSize || "12"}px !important;
  }

  .navigation {
    background-color: ${(props) =>
        props.profile.NavBackgroundColour || "#2c3e50"} !important;
    color: ${(props) => props.profile.NavTextColour || "#ffffff"} !important
  }
    .navigation .nav-link {
        color: ${(props) =>
            props.profile.NavTextColour || "#ffffff"} !important;
    }
  .btn {
    background-color: ${(props) =>
        props.profile.NavBackgroundColour || "#2c3e50"} !important;
    color: ${(props) => props.profile.NavTextColour || "#ffffff"} !important;
  }
  h1, h2, h3, h4, h5, h6 {
    color: ${(props) => props.profile.TitleColour || "#000000"} !important;
  }
  .main-container {
    background-color: ${(props) =>
        props.profile.ContainerBackgroundColour || "#eeeeee"} !important;
  }
  .message {
    background-color: ${(props) =>
        props.profile.ChatMessageBackgroundColour || "#ecf0f1"} !important;
    color: ${(props) =>
        props.profile.ChatMessageTextColour || "#000000"} !important;
  }
`;

interface ProfileThemeProviderProps {
    children: React.ReactNode;
}

export const ProfileThemeProvider: React.FC<ProfileThemeProviderProps> = ({
    children,
}) => {
    const [profile, setProfile] = useState<ThemeModel>({
        BackgroundColour: "#ffffff",
        TextColour: "#000000",
        FontSize: "12px",
        NavBackgroundColour: "#2c3e50",
        NavTextColour: "#ffffff",
        TitleColour: "#000000",
        ContainerBackgroundColour: "#eeeeee",
        ChatMessageBackgroundColour: "#ecf0f1",
        ChatMessageTextColour: "#2c3e50",
    });

    const refreshTheme = async () => {
        try {
            const data = await getProfile();
            setProfile(data);
        } catch (error) {
            console.error("Failed to load profile theme:", error);
        }
    };

    useEffect(() => {
        refreshTheme();
    }, []);

    return (
        <ProfileThemeContext.Provider value={{ refreshTheme }}>
            <GlobalStyle profile={profile} />
            {children}
        </ProfileThemeContext.Provider>
    );
};

// Create a context to expose the refresh function
export const ProfileThemeContext = React.createContext<{
    refreshTheme: () => Promise<void>;
}>({
    refreshTheme: async () => {},
});

// Create a hook to use the refresh function
export const useProfileTheme = () => React.useContext(ProfileThemeContext);
